import xeroLogo from '../../../../../../assets/images/logo-xero.svg';
import { Button } from '../../../../../../design-system/button/button';
import { Stack } from '../../../../../../design-system/stack/stack';
import { XeroFeaturesCard } from './xero-features-card';

type XeroConnectModalContentProps = {
  onContinue: () => void;
};

export const XeroConnectModalContent = ({ onContinue }: XeroConnectModalContentProps) => {
  return (
    <Stack space={10} align="stretch">
      <Stack space={3} align="center">
        <div className="h-16 w-16 rounded-full">
          <img
            src={xeroLogo}
            alt="Xero Logo"
            loading="eager"
            fetchpriority="high"
            className="h-full w-full object-contain"
          />
        </div>

        <Stack space={1} align="center">
          <h1 className="text-xl leading-7 font-medium tracking-tight text-black">Connect Seapoint to Xero</h1>

          <p className="text-center text-base leading-5 font-medium tracking-tight text-muted-foreground">
            Sync your accounts to automate bookkeeping and speed up reconciliation.
          </p>
        </Stack>
      </Stack>

      <XeroFeaturesCard />

      <Button variant="default" onClick={onContinue} className="w-full">
        Continue to Xero
      </Button>
    </Stack>
  );
};
